import { forwardRef, type ReactNode, type TextareaHTMLAttributes } from 'react';

import styles from './Field.module.scss';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  readonly label?: ReactNode;
  readonly hint?: ReactNode;
  readonly error?: ReactNode;
  readonly required?: boolean;
  readonly wrapperClassName?: string;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, error, required, className, wrapperClassName, id, ...rest },
  ref,
) {
  const controlClass = [
    styles.control,
    styles.textarea,
    error ? styles.invalid : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  const control = (
    <textarea ref={ref} id={id} className={controlClass} required={required} {...rest} />
  );

  if (!label && !hint && !error) {
    return control;
  }

  return (
    <div className={[styles.field, wrapperClassName ?? ''].join(' ')}>
      {label ? (
        <div className={styles.labelRow}>
          <label className={styles.label} htmlFor={id}>
            {label}
          </label>
          {required ? (
            <span className={styles.required} aria-hidden="true">
              *
            </span>
          ) : null}
        </div>
      ) : null}
      {control}
      {hint && !error ? <span className={styles.hint}>{hint}</span> : null}
      {error ? <span className={styles.error}>{error}</span> : null}
    </div>
  );
});
